export default __webpack_public_path__ + "static/TIMBERLINE-M-SERIES-28-D-front-WEB-a73ddaa43ff8334b27656041d615e09f.png";